import React from 'react';
import { isEmpty } from 'lodash/fp';
import classNames from 'classnames';
import { Icon } from 'ui';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import LibraryContentsList from './LibraryContentsList';
import Group from './Group';

const GroupsList = ({ libraryContents }) => (
  <LibraryContentsList libraryContents={libraryContents}>
    {content => <Group key={content.group.id} name={content.group.name} />}
  </LibraryContentsList>
);

const AdvancedView = ({
  toggleEditing,
  libraryContents,
  emptyStateActionText,
  disabled = false,
}) => {
  if (isEmpty(libraryContents)) {
    const buttonStyles = classNames('u-linkBtn', {
      'u-linkBtn--disabled': disabled,
    });

    return (
      <button
        type="button"
        className={buttonStyles}
        onClick={toggleEditing}
        disabled={disabled}
      >
        <Text variant={TEXT_VARIANTS.BODY_LINK}>
          <Icon name="add" /> {emptyStateActionText}
        </Text>
      </button>
    );
  }
  return <GroupsList libraryContents={libraryContents} />;
};

export default AdvancedView;
